<template>
  <span class="co-badge-optional co-display-14 badge rounded border-0 bg-co-gray-400 p-2 text-co-gray-50">
    <slot>任意</slot>
  </span>
</template>
